import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

// Cloudflare Turnstile widget (open link): loads Cloudflare's script once and renders the (usually invisible) check. The token
// it hands back is verified by the onboarding API; locally REACT_APP_TURNSTILE_SITE_KEY is Cloudflare's always-pass test key.
const SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let loading = null;
function loadScript() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!loading) loading = new Promise((resolve, reject) => { const s = document.createElement('script'); s.src = SCRIPT; s.async = true; s.onload = () => resolve(window.turnstile); s.onerror = reject; document.head.appendChild(s); });
  return loading;
}
export default function Turnstile({ onToken, onExpire, siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY }) {
  const ref = useRef(null);
  useEffect(() => {
    let id = null; let alive = true;
    loadScript().then(ts => { if (alive && ts && ref.current) id = ts.render(ref.current, { sitekey: siteKey, callback: onToken, 'expired-callback': () => onExpire && onExpire() }); }).catch(() => {});
    return () => { alive = false; if (id !== null && window.turnstile) window.turnstile.remove(id); };
  }, [siteKey]);   // eslint-disable-line react-hooks/exhaustive-deps
  return <Box ref={ref} sx={{ my: 1 }} />;
}
